// Auto-generated normalizer for table: ExamenesRespuestas
export function examenesRespuestasNormalize(row) {
  return {
    idExamenRespuesta: row.idExamenRespuesta ?? row.IdExamenRespuesta ?? row['IdExamenRespuesta'] ?? 0,
    idExamenIntento: row.idExamenIntento ?? row.IdExamenIntento ?? row['IdExamenIntento'] ?? 0,
    idPregunta: row.idPregunta ?? row.IdPregunta ?? row['IdPregunta'] ?? 0,
    correcta: row.correcta ?? row.Correcta ?? row['Correcta'] ?? '',
    explicacion: row.explicacion ?? row.Explicacion ?? row['Explicacion'] ?? '',
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
